<script lang="ts">
    import { getContext } from 'svelte'
    import { derived as sderived } from 'svelte/store'

    import Icon from '@iconify/svelte'
    import { toUnicode } from 'punycode-esm'

    import { gettext as _ } from 'hydria/services/gettext'

    import type { DomainHandler } from './domain'

    import Date from 'hydria/components/Date.svelte'
    import InternationalPhone from 'wdom/components/contacts/InternationalPhone.svelte'

    const Domain = getContext('Domain') as DomainHandler
    const status = sderived(Domain.status, ($status) => $status)

    let notifs = $derived(sderived(Domain.lastNotifications, ($v) => $v))
</script>

<div class="card">
    <div class="card-title text-primary">{$_('Last notifications')}</div>
    {#if $status != 'ready'}
        <div class="card-body"><div class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></div></div>
    {:else if $notifs && $notifs.length}
        <div class="card-body">
            <table class="table table-striped table-condensed">
                <thead>
                    <tr>
                        <th style="width: 170px">{$_('Date')}</th>
                        <th style="width: 60px">{$_('Mode')}</th>
                        <th style="width: 240px">{$_('Destination')}</th>
                        <th>{$_('Domains')}</th>
                        <th>{$_('Zones')}</th>
                        <th style="width: 6.625rem">{$_('Skipped?')} <span style="font-size: 0.7em; vertical-align: middle; cursor: help;" class="tt-left tt-below" data-tooltip="Cette notification n’a pas été envoyée : une autre notification similaire (sur durée différente) contenait déjà l’information.">[F]</span></th>
                    </tr>
                </thead>
                <tbody>
                    {#each $notifs as notif}
                        <tr>
                            <td><Date value={notif.stamp} format="h-table-s" /></td>
                            <td>{notif.delivery_mode}</td>
                            <td>
                                {#if notif.delivery_mode == 'sms'}<InternationalPhone phone={notif.delivery_args.phone} />
                                {:else}{notif.delivery_args.email}
                                {/if}
                            </td>
                            <td>
                                {#if notif.domain_idnas.length}
                                    {#each notif.domain_idnas as idna}
                                        <span class="enum"><span>{toUnicode(idna)}</span></span>
                                    {/each}
                                {:else}
                                    <Icon inline icon="mdi:minus" />
                                {/if}
                            </td>
                            <td>
                                {#if notif.zone_idnas.length}
                                    {#each notif.zone_idnas as idna}
                                        <span class="enum"><span>{toUnicode(idna)}</span></span>
                                    {/each}
                                {:else}
                                    <Icon inline icon="mdi:minus" />
                                {/if}
                            </td>
                            <td><Icon inline icon={notif.skipped_on_duplicate ? 'mdi:check' : 'mdi:close'} /></td>
                        </tr>
                    {/each}
                </tbody>
            </table>
        </div>
    {:else}
        <div class="card-body">Aucune notification.</div>
    {/if}
</div>
